"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const TableHeader_1 = __importDefault(require("./TableHeader"));
const typography_1 = require("../../shared/typography");
const icons_1 = require("../../atoms/icons");
const tags_1 = require("../../atoms/tags");
const checkProgressValue_1 = __importDefault(require("./checkProgressValue"));
const fixValuesArray = (values) => {
    const copy = [...values];
    const fakeDataArray = new Array(8 - copy.length).fill(" ");
    copy.splice(1, 0, ...fakeDataArray);
    return copy;
};
const fillEmptyValues = (elements) => {
    if (elements.length < 7) {
        const nullElements = new Array(7 - elements.length)
            .fill(undefined)
            .map((_, i) => (0, jsx_runtime_1.jsx)("div", {}, i));
        return nullElements.concat(elements);
    }
    return elements;
};
const renderProgressValues = (key) => (value, index) => {
    if (value === " ")
        return (0, jsx_runtime_1.jsx)("div", {}, key + index);
    if (typeof value === "string") {
        return ((0, jsx_runtime_1.jsx)(Item, { children: (0, jsx_runtime_1.jsx)(tags_1.Tag, { variant: "silver", children: value || "-" }, void 0) }, key + index));
    }
    if ("status" in value && parseInt(value.status) >= 80) {
        return ((0, jsx_runtime_1.jsx)(Item, { children: (0, jsx_runtime_1.jsx)(tags_1.Tag, { variant: "silver", children: `${value.status}%` || "-" }, void 0) }, key + index));
    }
    if ("value" in value) {
        return ((0, jsx_runtime_1.jsx)(Item, { children: (0, jsx_runtime_1.jsx)(tags_1.Tag, { variant: "silver", children: value.value || "-" }, void 0) }, key + index));
    }
    return (0, jsx_runtime_1.jsx)("div", { children: (0, checkProgressValue_1.default)(value === null || value === void 0 ? void 0 : value.status) }, key + index);
};
const renderRecoveryRows = (valuesMap, _isProgress, isAverage) => {
    const elements = [];
    for (const [key, values] of valuesMap.entries()) {
        const recoveryValues = isAverage && values.length < 8
            ? fixValuesArray(values)
            : values;
        elements.push((0, jsx_runtime_1.jsxs)(Row, { children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { children: key }, void 0), (0, jsx_runtime_1.jsx)("div", { children: fillEmptyValues(recoveryValues.map((value, index) => {
                        if (value === " ")
                            return (0, jsx_runtime_1.jsx)("div", {}, key + index);
                        return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", color: "light-grey", children: value || "-" }, void 0) }, key + index));
                    })) }, void 0)] }, key));
    }
    return elements;
};
const renderProgressionRows = (valuesMap, _isProgress, isAverage) => {
    const elements = [];
    if (isAverage && valuesMap.size !== 0) {
        // motivation
        const [key, values] = [...valuesMap][0];
        valuesMap.set(key, fixValuesArray(values));
    }
    for (const [key, values] of valuesMap.entries()) {
        const progressValues = values;
        const progress = progressValues.map(renderProgressValues(key));
        elements.push((0, jsx_runtime_1.jsxs)(Row, { children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { children: key }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [isAverage && progressValues.length < 8 && (0, jsx_runtime_1.jsx)("div", {}, void 0), fillEmptyValues(progress)] }, void 0)] }, key));
    }
    return elements;
};
exports.default = ({ title, valuesMap, showChecklistChange = false, isProgress = false, startDay, isAverage = false, onHeaderClick = () => { }, onLogbookClick = () => { }, getDateFns }) => {
    return ((0, jsx_runtime_1.jsxs)(ContentWrapper, { "data-cy": "progress-overview", children: [(0, jsx_runtime_1.jsx)(TableHeader_1.default, { title: title, startDay: startDay, isAverage: isAverage, onHeaderClick: onHeaderClick, onLogbookClick: onLogbookClick, getDateFns: getDateFns, showChecklistChange: showChecklistChange }, void 0), (0, jsx_runtime_1.jsx)(Wrapper, { children: isProgress
                    ? renderProgressionRows(valuesMap, isProgress, isAverage)
                    : renderRecoveryRows(valuesMap, isProgress, isAverage) }, void 0)] }, void 0));
};
const ContentWrapper = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid
    ${({ theme }) => theme.colors.silverBase};
  border-radius: ${({ theme }) => theme.utils.radius};
`;
const Wrapper = styled_components_1.default.div `
  padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};

  & > div:not(:last-of-type) {
    border-bottom: 1px solid
      ${({ theme }) => theme.colors.silverLighten40};
  }

  & > div:first-of-type {
    padding-top: 0;
  }

  & > div:last-of-type {
    padding-bottom: 0;
  }
`;
const Row = styled_components_1.default.div `
  display: flex;
  width: 100%;

  &:not(:last-of-type) {
    padding: ${({ theme }) => `${theme.spacings.xs} ${0}`};
  }

  &:last-of-type {
    padding-top: ${({ theme }) => theme.spacings.xs};
  }

  & > h2 {
    flex: 3;
    font-weight: 400;
    margin-bottom: 0;
    word-break: break-word;
  }
  & > div {
    display: flex;
    flex: 8;

    & > div {
      display: flex;
      justify-content: center;
      width: 100%;
    }
  }
`;
const Item = styled_components_1.default.div `
  & > span {
    margin: 0;
    min-width: 1.5rem;
    max-width: 3rem;
    text-align: center;
    white-space: unset;
  }
`;
//# sourceMappingURL=RecoveryWeekPreviewTable.js.map